import { connect } from 'react-redux';
import { GetPayrollCount, GetPayrolls } from './actions';
import Payroll from './Payroll';

const mapStateToProps = (state) => {
	return {
		user: state.auth.user,
		records: state.payroll.payrolls,
		recordCount: state.payroll.count,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getRecords: (searchObject, page, pageSize) => dispatch(GetPayrolls(searchObject, page, pageSize)),
		getRecordCount: (searchObject) => dispatch(GetPayrollCount(searchObject)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Payroll);
